import { render, staticRenderFns } from "./SelectedOther.vue?vue&type=template&id=32f8737e&scoped=true&"
import script from "./SelectedOther.vue?vue&type=script&lang=js&"
export * from "./SelectedOther.vue?vue&type=script&lang=js&"
import style0 from "./SelectedOther.vue?vue&type=style&index=0&id=32f8737e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f8737e",
  null
  
)

export default component.exports